/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-adverse-event.reducer';

export const TreatmentAdverseEventDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentAdverseEventEntity = useAppSelector(state => state.treatmentAdverseEvent.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentAdverseEventDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.detail.title">TreatmentAdverseEvent</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.id}</dd>
          <dt>
            <span id="eventDate">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.eventDate">Event Date</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.eventDate}</dd>
          <dt>
            <span id="eventDescription">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.eventDescription">Event Description</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.eventDescription}</dd>
          <dt>
            <span id="severity">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.severity">Severity</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.severity}</dd>
          <dt>
            <span id="impactedParameters">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.impactedParameters">Impacted Parameters</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.impactedParameters}</dd>
          <dt>
            <span id="mitigationStrategiesTaken">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.mitigationStrategiesTaken">
                Mitigation Strategies Taken
              </Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.mitigationStrategiesTaken}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentAdverseEventEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.plan">Plan</Translate>
          </dt>
          <dd>{treatmentAdverseEventEntity.plan ? treatmentAdverseEventEntity.plan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.cycles">Cycles</Translate>
          </dt>
          <dd>{treatmentAdverseEventEntity.cycles ? treatmentAdverseEventEntity.cycles.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.eventType">Event Type</Translate>
          </dt>
          <dd>{treatmentAdverseEventEntity.eventType ? treatmentAdverseEventEntity.eventType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.eventResult">Event Result</Translate>
          </dt>
          <dd>{treatmentAdverseEventEntity.eventResult ? treatmentAdverseEventEntity.eventResult.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.regimen">Regimen</Translate>
          </dt>
          <dd>{treatmentAdverseEventEntity.regimen ? treatmentAdverseEventEntity.regimen.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-adverse-event" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-adverse-event/${treatmentAdverseEventEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentAdverseEventDetail;
